import { render } from "./GlossariesList.vue?vue&type=template&id=3fbdb284&scoped=true"
import script from "./GlossariesList.vue?vue&type=script&lang=js"
export * from "./GlossariesList.vue?vue&type=script&lang=js"

import "./GlossariesList.vue?vue&type=style&index=0&id=3fbdb284&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbdb284"]])

export default __exports__